import { FormattedCurrency } from '@iwIntlProvider/FormattedCurrency';
import { IconInfoCircleOutline } from '@iwoca/icons';
import { FormattedMessage } from 'react-intl';

import { TopUpStatusAlertBox } from './TopUpStatusAlertBox';
import styles from '../TopUpStatusAlertBox.module.css';

export const NotYetTopUpEligibleAlert = ({
    amountToRepayBeforeTopUp
}: {
    amountToRepayBeforeTopUp: number;
}) => {
    return (
        <TopUpStatusAlertBox
            variant="cancel"
            icon={<IconInfoCircleOutline className={styles.blueAlertBoxIcon} />}
            className={styles.blueAlertBox}
            description={
                <>
                    <strong>
                        <FormattedMessage
                            id="_.outstanding_view.notYetTopupEligibleAlertText"
                            defaultMessage="You can request more funds once you've repaid {amount} -"
                            values={{
                                amount: (
                                    <FormattedCurrency
                                        value={amountToRepayBeforeTopUp}
                                    />
                                )
                            }}
                        />
                    </strong>{' '}
                    <FormattedMessage
                        id="_.outstanding_view.notYetTopupEligibleAlertDescription"
                        defaultMessage="You've passed our eligibility checks but your approval will still be subject to a credit review"
                    />
                </>
            }
        />
    );
};
